<template>
  <div class="unread-messages">
    <box :title="$t('messages')" v-if="messages.length > 0">
      <v-simple-table fixed-header>
        <template v-slot:default>
          <thead class="bg-thead-level-2">
            <tr>
              <th class="">{{ $t("Subject") }}</th>
              <th class="">{{ $t("SentDate") }}</th>
              <th class=""></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in messages" :key="index" class="">
              <td>
                <strong class="text-primary">{{
                  item.Subject
                }}</strong>
              </td>
              <td>{{ item.SentDate }}</td>
              <td @click="showMessage">
                <span class="pointer">{{ $t("show") }}</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </box>
  </div>
</template>

<script>
import EosUtils from "../../utils/EosUtils";
export default {
  props: { args: Object },
  data() {
    return {
      messages: [],
    };
  },
  mounted() {
    this.getArgs();
  },
  watch: {
    args() {
      this.getArgs();
    },
  },
  methods: {
    getArgs() {
      var perno = this.$store.state.auth.auth.username;
      if (this.args && this.args.pid) {
        perno = this.args.pid;
      }
      this.GetUnreadInbox(perno);
    },
    GetUnreadInbox(perno) {
      this.$store.dispatch("GetUnreadInbox", { perno }).then((result) => {
        if (result.type === "success") {
          this.messages = result.data.Table;
        }
      });
    },
    showMessage() {
      if (EosUtils.isWebKartAdmin()) {
        this.$router.push({ name: "admin-inbox" });
      } else {
        this.$router.push({ name: "messages" });
      }
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
.bg-thead-level-2 {
  background: #ac2828 !important;
}
</style>